/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Form, FormGroup, Input, Label, Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Alert from 'react-s-alert';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const Sessions = props => {

    // states
    const [sessions, setSessions] = useState([]);

    const [modal, setModal] = useState({ isVisible: false, data: {} });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [isLoading, setIsLoading] = useState(false);
    const [client, setClient] = useState('');
    const [provider, setProvider] = useState('');
    const [mode, setMode] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [status, setStatus] = useState();

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        handleSearchSubmit(null);
    }, [pagination.page, pagination.limit]);

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Sessions hadlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleSearchSubmit = e => {
        if (e) e.preventDefault();
        try {
            if (!isLoading) {
                setIsLoading(true);
                AdminService.getSessions(pagination.limit, pagination.page, client, provider, mode, fromDate, toDate, status).then(data => {
                    setSessions(data.sessions);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at Admin Sessions hadlePagination', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Sessions</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        Session List
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%">
                                <thead>
                                    <tr>
                                        <td colSpan="7" className="border-0 px-0">
                                            <Form inline onSubmit={handleSearchSubmit}>
                                                {/* <FormGroup className="mr-2">
                                                    <Label style={theme.formBodyText} >From</Label>
                                                    <Input type="date" id="fromDate" name="fromDate" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="form-control" style={theme.formInput}/>
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="toDate" style={theme.formBodyText} >To</Label>
                                                    <Input type="date" id="toDate" name="toDate" value={toDate} onChange={(e) => setToDate(e.target.value)} className="form-control" style={theme.formInput}/>
                                                </FormGroup> */}
                                                <FormGroup className="mr-2">
                                                    <Label for="exampleEmail" className="mr-1" for="client" style={theme.formBodyText}>Client</Label>
                                                    <Input type="text" id="client" name="client" style={Object.assign({ marginRight: "-20px", paddingRight: "20px" }, theme.formInput)} onChange={(e) => setClient(e.target.value)} value={client} />
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("client").value = ""; setClient(""); }}><i className="fa fa-times"></i></span>
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="exampleEmail" className="mr-1" for="provider" style={theme.formBodyText} >Counsellor</Label>
                                                    <Input type="text" id="provider" name="provider" value={provider} onChange={(e) => setProvider(e.target.value)} className="form-control" style={Object.assign({ marginRight: "-20px", paddingRight: "20px" }, theme.formInput)} />
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("provider").value = ""; setProvider(""); }}><i className="fa fa-times"></i></span>
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="exampleEmail" className="mr-1" for="mode" style={theme.formBodyText}>Service</Label>
                                                    <Input type="select" id="mode" name="mode" style={theme.formInput} onChange={(e) => setMode(e.target.value)} value={mode} >
                                                        <option value="">All</option>
                                                        <option value="Chat">Chat</option>
                                                        <option value="Call">Call</option>
                                                        <option value="Video">Video</option>
                                                    </Input>
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="exampleEmail" className="mr-1" for="status" style={theme.formBodyText}>Status</Label>
                                                    <Input type="select" id="status" name="status" style={theme.formInput} onChange={(e) => setStatus(e.target.value)} value={status} >
                                                        <option value="">All</option>
                                                        <option value="false">Pending</option>
                                                        <option value="true">Completed</option>
                                                    </Input>
                                                </FormGroup>
                                                <Button type="submit" className="my-auto" style={Object.assign({ height: 'fit-content' }, theme.formButton)} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Search</Button>
                                            </Form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Date-Time</th>
                                        <th>Client</th>
                                        <th>Counsellor</th>
                                        <th>Service</th>
                                        <th>IsCompleted</th>
                                        <th>PaymentId</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sessions.map((item, index) => (
                                            // item.client && item.provider ?
                                            <ErrorBoundary errorAt={`At Admin Sessions Table${index}`}>
                                                <tr key={index}>
                                                    <td>{moment(item.date).format('DD-MM-YYYY hh:mm A')}</td>
                                                    <td>{item.client ? item.client.email : '-'}</td>
                                                    <td>{item.provider ? item.provider.email : '-'}</td>
                                                    <td>{item.modeOfServiceSelected}</td>
                                                    <td>{item.status ? 'Completed' : 'Pending'}</td>
                                                    {
                                                        item.paymentId && item.paymentId.payment === 'Free Session' ?
                                                            <td colSpan="2">Free Session</td>
                                                            : [
                                                                <td key='t1'>{item.paymentId ? item.paymentId.payment.razorpay_payment_id : '-'}</td>,
                                                                <td key='t2'>{item.paymentId ? item.paymentId.payment.amount : '-'}</td>
                                                            ]
                                                    }
                                                </tr>
                                            </ErrorBoundary>
                                            // : null
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="7" className="border-0 pb-0">
                                            <div className="d-flex">
                                                {/* <div className="d-flex p-2">
                                                    <span>Showing {pagination.totalResults==0 ? 0 : 1 } to</span>
                                                    <Input style={{width:'47px', height: '30px', padding: '14px 5px', margin: '0 5px'}} id="limit" minLength="1" maxLength="4" name="limit" value={pagination.limit>pagination.totalResults ? pagination.totalResults : pagination.limit} onChange={e => handlePagination(e,null)} ></Input>
                                                    <span>of {pagination.totalResults} entries</span>
                                                </div> */}
                                                <ErrorBoundary errorAt="At Admin Sessions Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, data: {} })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Data</span></ModalHeader>
                <ModalBody>
                    <p><span style={{ fontWeight: "600" }}>Payment id:</span><span className="ml-1">{modal.data.razorpay_payment_id}</span></p>
                    <p><span style={{ fontWeight: "600" }}>Amount:</span><span className="ml-1">{modal.data.amount}</span></p>
                </ModalBody>
            </Modal>
        </main>
    )

}

export default Sessions;